const siteURL = 'https://dev.mealwell.com/';
const backURL = 'https://api.dev.mealwell.com/';
const backURLApi = `${backURL}api/v1.2/`;

const config = {
  siteURL,
  backURL,
  backURLApi,
};

export default config;
